import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
  },
  sectionTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
  },
  row: {
    position: 'relative',
    backgroundColor: theme.palette.text.white,
    border: `1px solid ${theme.palette.labraChat.border}`,
    borderRadius: 8,
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
    '&:hover, &:focus-visible': {
      backgroundColor: theme.palette.labraChat.hoverBgAlt,
      outline: 'none',
    },
    '&:hover .labra-row-action, &:focus-visible .labra-row-action': {
      visibility: 'visible',
      opacity: 1,
    },
  },
  // The action sits absolutely over the right end of the row so the text always
  // spans the full width and truncates underneath it. It reveals on row hover,
  // with a gradient fading the truncated text into the button.
  rowAction: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    paddingRight: 12,
    paddingLeft: 48,
    background: `linear-gradient(to right, transparent, ${theme.palette.labraChat.hoverBgAlt} 48px)`,
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity 0.15s ease',
    pointerEvents: 'none',
  },
  rowActionBtn: {
    backgroundColor: theme.palette.text.white,
    border: `1px solid ${theme.palette.labraChat.borderStrong}`,
    borderRadius: 4,
    padding: '2px 8px',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    letterSpacing: '-0.15px',
    color: theme.palette.labraChat.darkText,
    whiteSpace: 'nowrap',
  },
  rowIconContainer: {
    width: 28,
    height: 28,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  rowIcon: {
    fontSize: 16,
    color: theme.palette.labraText.description,
  },
  rowText: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 14,
    lineHeight: '20px',
    fontFamily: 'Inter, sans-serif',
    textAlign: 'left',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    letterSpacing: '0.25px',
  },
  loadingRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 0',
    color: theme.palette.labraText.description,
  },
  emptyRow: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    padding: '8px 0',
  },
  viewMoreRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    alignSelf: 'flex-start',
  },
  viewMoreLink: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.icon.blue,
    background: 'none',
    border: 'none',
    padding: '2px 0',
    cursor: 'pointer',
    alignSelf: 'flex-start',
  },
}))
